<div class="container-fluid">
    <div class="d-flex justify-content-center">
        @if (mostrarOpcionesDescarga) {
            <div class="row g-3 align-items-center" >
                <div class="col-auto mt-3">
                    <label for="inputPassword6" class="col-form-label">Opciones de descarga:</label>
                </div>
                <div class="col-auto mt-3">
                    <div class="btn-group" role="group" aria-label="Basic outlined example">
                        <button type="button" class="btn btn-sm btn-outline-primary" (click)="descargar('PDF');"><i
                                class="bi bi-filetype-pdf"></i>
                            Pdf</button>
                        <button type="button" class="btn btn-sm btn-outline-primary" (click)="descargar('EXCELOPENXML');"><i
                                class="bi bi-file-earmark-spreadsheet"></i> Excel</button>
                    </div>
                </div>
            </div>
        }
    </div>
    <br />
    <div class="row">
        @if (pdfGenerado) {
            <ngx-extended-pdf-viewer [src]="pdfGenerado" [showPresentationModeButton]="true"
                [showOpenFileButton]="false" [height]="'100%'">
            </ngx-extended-pdf-viewer>
        }
        @else {
            <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
        }        
    </div>
</div>